/* unplugin-vue-components disabled */import { render } from "./LiveNow.vue?vue&type=template&id=2cf44b4b&scoped=true"
import script from "./LiveNow.vue?vue&type=script&lang=js"
export * from "./LiveNow.vue?vue&type=script&lang=js"

import "./LiveNow.vue?vue&type=style&index=0&id=2cf44b4b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf44b4b"]])

export default __exports__